module.exports = __webpack_public_path__ + "static/img/4物流.77194a8d.jpg";